import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
  Signal,
} from '@angular/core';

import { ALLOWED_MANUFACTURERS, ManufactureType } from '../../consts/manufactures.const';
import { ThemeService } from '../../services/theme.service';

@Component({
  selector: 'wpp-header',
  // core-ui ships a component with this same selector; the extra host attribute keeps the
  // two component ids apart (NG0912).
  host: { 'data-wpp-planner': '' },
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private readonly themeService: ThemeService = inject(ThemeService);

  public brandUrl = input<string>();
  public brandClicked = output<void>();

  // Resolves the brand wordmark URL when a manufacturer theme is active.
  // Returns null when no brand is loaded (default state), so the template can
  // omit the brand-logo entirely instead of rendering a broken image.
  protected readonly brandWordmarkSrc: Signal<string | null> = computed((): string | null => {
    const brand: ManufactureType | null = this.themeService.currentBrand();
    if (!brand || !ALLOWED_MANUFACTURERS.includes(brand)) return null;
    // White wordmark on a transparent background, tight-cropped (no padding):
    // keyed out from the Figma header crops since Figma's MCP asset endpoint
    // returns the master Skoda wordmark for every brand instance.
    // Replace with official brand SVGs from Pon brand assets when available.
    return `/assets/images/logos/brand-${brand}-white.png`;
  });
}
